import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full py-4 px-6 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto">
          <a href="/">
            <img 
              src={LOGO_URL} 
              alt="Just Cleaned" 
              className="h-12 w-auto object-contain"
            />
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-semibold text-gray-900 mb-8">Cookie Policy</h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">Last updated: January 2025</p>
            
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">What Are Cookies</h2>
              <p>Cookies are small text files stored on your device when you visit our website. They help us understand how visitors use our site and improve your experience.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Cookies We Use</h2>
              <p>We use the following types of cookies:</p>
              
              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Essential Cookies</h3>
              <p>Required for the website to function properly. These cannot be disabled.</p>
              
              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Performance Cookies</h3>
              <p>Help us understand how visitors interact with our website by collecting anonymous usage data.</p>
              
              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Advertising Cookies</h3>
              <p>We use the Facebook Pixel to measure the effectiveness of our advertising and to deliver relevant content. This helps us understand which ads lead to enquiries.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Managing Cookies</h2>
              <p>You can control and delete cookies through your browser settings. Note that disabling certain cookies may affect website functionality.</p>
              <p className="mt-2">By continuing to use our website, you consent to our use of cookies as described in this policy.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p>If you have questions about our use of cookies, please contact us at:</p>
              <p className="mt-2"><strong>Email:</strong> justcleanedltd@gmail.com</p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-8 bg-white border-t border-gray-100 mt-12">
        <div className="max-w-4xl mx-auto text-center text-gray-500 text-sm">
          <p>Just Cleaned • Communal block cleaning</p>
        </div>
      </footer>
    </div>
  );
};

export default CookiePolicy;
